import { Component } from '@poa/core';
import { action, observable } from '@poa/state';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';

class LettersPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa
  env; // injected by Poa

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems() {
    this.env.http
      .get('letters/unread/')
      .then(
        action(({ data }) => {
          this.localState.unreadLetters.meta.hasError = false;
          this.localState.unreadLetters.meta.loaded = true;
          this.localState.unreadLetters.data.replace(data);
        })
      )
      .catch(
        action(() => {
          this.localState.unreadLetters.meta.hasError = true;
          this.localState.unreadLetters.meta.loaded = false;
        })
      );
  }

  localState = observable({
    isModalOpened: false,
    selectedProfileId: null,
    tooltipOpened: null,
    unreadLetters: { data: [], meta: { hasError: false, loaded: false } }
  });

  render() {
    const body = this.localState.unreadLetters.data.map((letter, key) => {
      return {
        section_1: {
          sender: {
            value: letter.sender
          },
          recipient: {
            value: letter.recipient
          },
          date: {
            value: letter.date
          },
          free: {
            value: letter.free ? this.t('yes') : this.t('no')
          },
          flirt: {
            value: letter.flirt ? this.t('yes') : this.t('no')
          },
          read: {
            value: letter.read ? this.t('yes') : this.t('no')
          },
          url: {
            value: letter.url,
            type: 'link',
            label: this.t('doRead')
          }
        }
      };
    });

    const data = {
      thead: {
        section_1: [
          {
            verbose_name: this.t('sender'),
            name: 'sender'
          },
          {
            verbose_name: this.t('recipient'),
            name: 'recipient'
          },
          {
            verbose_name: this.t('date'),
            name: 'date'
          },
          {
            verbose_name: this.t('free'),
            name: 'free'
          },
          {
            verbose_name: this.t('flirt'),
            name: 'flirt'
          },
          {
            verbose_name: this.t('read'),
            name: 'read'
          },
          {
            verbose_name: this.t('doRead'),
            name: 'url'
          }
        ]
      },
      tbody: body
    };

    const columnsSettings = data.thead.section_1.map(item => ({
      name: item.name,
      sectionId: 'section_1',
      isSelected: true,
      width: 100,
      label: item.verbose_name
    }));

    return (
      <RouteLoading meta={this.localState.unreadLetters.meta}>
        <div className="content">
          <Navbar />
          <div className="container">
            <div className="inner">
              <div className="inner-scroll unread-letters-table">
                <DataTable
                  ref={node => (this.node = node)}
                  data={data}
                  tableFiltersKey="letters-filters"
                  isDecimalThunk={() => true}
                  columnSettings={columnsSettings}
                  account_filters={null}
                  selectors={{
                    selectedPreset: {
                      columnsConfiguration: columnsSettings
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </RouteLoading>
    );
  }
}

export default Component({ namespaces: ['letters'] })(LettersPage);
